export default "__VITE_ASSET__CloEN612__"